:host {
  --aha-radio-button--background-selected: var(--theme-primary-background);
  --aha-radio-button--top-left-border-radius: var(--Common--border-radius);
  --aha-radio-button--top-right-border-radius: var(--Common--border-radius);
  --aha-radio-button--bottom-right-border-radius: var(--Common--border-radius);
  --aha-radio-button--bottom-left-border-radius: var(--Common--border-radius);
  --aha-radio-button--border-radius: var(--aha-radio-button--top-left-border-radius)
    var(--aha-radio-button--top-right-border-radius)
    var(--aha-radio-button--bottom-right-border-radius)
    var(--aha-radio-button--bottom-left-border-radius);
  --aha-radio-button--color: var(--theme-secondary-text);
  --aha-radio-button--padding: var(--spacer-1) var(--spacer-2);

  display: inline-flex;
  align-items: stretch;
  border-radius: var(--aha-radio-button--border-radius);
  white-space: nowrap;
  position: relative;
  height: 100%;
}
:host(:hover) {
  --aha-radio-button--background: var(--aha-radio-button--background-selected);
}
:host([selected]) {
  --aha-radio-button--color: inherit;
}

button {
  font: inherit;
  display: inline-flex;
  align-items: center;
  gap: var(--spacer-2);
  border: none;
  background: var(--aha-radio-button--background);
  color: var(--aha-radio-button--color);
  border-radius: inherit;
  cursor: pointer;
  padding: var(--aha-radio-button--padding);
  height: 100%;
  width: 100%;
}
